import { createStackNavigator } from "@react-navigation/stack";
import React, { useEffect } from 'react';
import { observer } from "mobx-react-lite";
import { AppParams } from "./ParamsList/AppParams";
import Tabs from "./Tabs";

const AppStack = createStackNavigator<AppParams>()

import * as Notifications from "expo-notifications"

const App = () => {

    useEffect(() => {
        const subscription = Notifications.addNotificationReceivedListener(() => "");
    }, [])

    return (
        <AppStack.Navigator screenOptions={{ headerShown: false }}>
            <AppStack.Screen name="App" component={Tabs} />
        </AppStack.Navigator>
    )
}

export default observer(App)